var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9975 15.9201V18.9201C20.9986 19.1986 20.9416 19.4743 20.83 19.7294C20.7184 19.9846 20.5548 20.2137 20.3496 20.402C20.1443 20.5902 19.9021 20.7336 19.6382 20.8228C19.3744 20.912 19.0949 20.9452 18.8175 20.9201C15.7403 20.5857 12.7845 19.5342 10.1875 17.8501C7.77132 16.3148 5.72283 14.2663 4.18749 11.8501C2.49747 9.2413 1.44573 6.27109 1.11749 3.1801C1.0925 2.90356 1.12537 2.62486 1.21399 2.36172C1.30262 2.09859 1.44506 1.85679 1.63226 1.65172C1.81945 1.44665 2.0473 1.28281 2.30128 1.17062C2.55527 1.05843 2.82983 1.00036 3.10749 1.0001H6.10749C6.5928 0.995321 7.06328 1.16718 7.43125 1.48363C7.79922 1.80008 8.03957 2.23954 8.10749 2.7201C8.23411 3.68016 8.46894 4.62282 8.80749 5.5301C8.94204 5.88802 8.97115 6.27701 8.8914 6.65098C8.81164 7.02494 8.62635 7.36821 8.35749 7.6401L7.08749 8.9101C8.51105 11.4136 10.5839 13.4865 13.0875 14.9101L14.3575 13.6401C14.6294 13.3712 14.9726 13.1859 15.3466 13.1062C15.7206 13.0264 16.1096 13.0556 16.4675 13.1901C17.3748 13.5286 18.3174 13.7635 19.2775 13.8901C19.7633 13.9586 20.2069 14.2033 20.524 14.5776C20.8412 14.9519 21.0097 15.4297 20.9975 15.9201Z",
    stroke: "#403C6F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/callIcon.78408fbbc8d2106b22fc23ca2bd52548.svg";
export { ForwardRef as ReactComponent };